// The dealer's mobile number field on the sign-in page. It holds the 10
// national digits only (+91 is drawn beside it) and shows them grouped the
// way Indian numbers are read aloud: 98765 43210.

export const MOBILE_LENGTH = 10;
const GROUP = 5;

export function formatMobile(digits) {
  return digits.length > GROUP ? `${digits.slice(0, GROUP)} ${digits.slice(GROUP)}` : digits;
}

// Where the caret sits in the formatted text after `count` digits.
function caretAfter(digits, count) {
  return count > GROUP && digits.length > GROUP ? count + 1 : count;
}

/**
 * Reads one edit of the field: `value` is the text after the edit and
 * `caret` the caret in it. Typing stops at 10 digits, like a maxlength
 * field. A pasted or autofilled number keeps working with its prefix
 * (+91 98765 43210, 098765 43210), which is dropped to leave the 10 digits.
 * Returns the digits and where the caret goes in their formatted text, so an
 * edit mid-number doesn't throw the caret to the end.
 */
export function editMobile(prevDigits, { value, caret = value.length, inputType }) {
  let digits = value.replace(/\D/g, "");
  let before = value.slice(0, caret).replace(/\D/g, "").length;

  // Backspace or Delete on the space between the groups takes the digit
  // beside it, rather than the space coming straight back.
  if (digits === prevDigits && value.length < formatMobile(prevDigits).length) {
    if (inputType === "deleteContentBackward" && before > 0) {
      digits = digits.slice(0, before - 1) + digits.slice(before);
      before -= 1;
    } else if (inputType === "deleteContentForward") {
      digits = digits.slice(0, before) + digits.slice(before + 1);
    }
  }

  const prefix =
    digits.length === 12 && digits.startsWith("91") ? 2
      : digits.length === 11 && digits.startsWith("0") ? 1
        : 0;
  if (prefix) {
    digits = digits.slice(prefix);
    before = Math.max(0, before - prefix);
  }

  if (digits.length > MOBILE_LENGTH) {
    if (prevDigits.length === MOBILE_LENGTH) {
      const kept = before - (digits.length - MOBILE_LENGTH);
      return { digits: prevDigits, caret: caretAfter(prevDigits, Math.max(0, kept)) };
    }
    digits = digits.slice(0, MOBILE_LENGTH);
  }
  return { digits, caret: caretAfter(digits, Math.min(before, digits.length)) };
}
